const templateUrl = require('./../views/partials/email-verify-popup.html');

function emailVerifyPopupDirective($timeout, $rootScope) {
  "ngInject";

  return {
    restrict: 'A',
    scope: {},
    replace: true,
    templateUrl,
    link: function(scope, el, attrs) {

      scope.showPopup = false;

      scope.handleCallback = function() {
        scope.showPopup = false;
      };

      $('.close-popup').on('click', function() {
        $('body').removeClass('stop-scrolling');
      });

      $rootScope.$on('showEmailPopUp', function(e, callback) {
        window.scroll(0, 0);
        $('body').addClass('stop-scrolling');
        scope.showPopup = true;
        console.log(e, callback);
        if(typeof callback === 'function') {
          scope.handleCallback = function() {
            scope.showPopup = false;
            $('body').removeClass('stop-scrolling');
            callback();
          };
        }
      });
    
    }
  };
}

export default emailVerifyPopupDirective;



// WEBPACK FOOTER //
// ./js/containers/users/directives/emailVerifyPopup.js